import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog"; // ודא שהנתיב ל-dialog נכון
import NewsletterSignup from './newsletterSignup'; // נבא את טופס ההרשמה הקיים
import { Mail } from 'lucide-react';

export default function SubscribeModal({ open, onOpenChange }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[425px] bg-[#f8f5f2] border-[#eebbc3]">
                <DialogHeader className="text-right">
                    <div className="flex justify-center items-center mb-4">
                        <div className="p-3 bg-[#eebbc3]/20 rounded-full">
                            <Mail className="w-8 h-8 text-[#232946]" />
                        </div>
                    </div>
                    <DialogTitle className="text-2xl font-bold text-center text-[#232946]">הצטרפות לרשימת התפוצה</DialogTitle>
                    <DialogDescription className="text-center text-[#8890b3] pt-2">
                        רוצה לקבל עדכונים על מאמרים חדשים, תובנות ודיונים מעמיקים ישירות למייל?
                    </DialogDescription>
                </DialogHeader>
                <div className="py-4">
                    {/* אנחנו משתמשים כאן בקומפוננטת הניוזלטר הקיימת.
                      הפעם במקום להציג אותה עם הרקע הכהה שלה, נציג רק את הטופס.
                      נצטרך לערוך מעט את NewsletterSignup כדי לאפשר זאת.
                    */}
                    <NewsletterSignup compact={true} />
                </div>
            </DialogContent>
        </Dialog>
    );
}